import React from 'react';

interface LogoProps {
  className?: string;
}

/**
 * RestoreLink Logo Component - Text Only
 * Uses red (#dc2626) and black (#111827) brand colors
 */
export function Logo({ className = 'h-8' }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 40"
      className={className}
    >
      <text
        x="0"
        y="30"
        fontFamily="'Helvetica Neue', Helvetica, Arial, sans-serif"
        fontSize="28"
        fontWeight="bold"
      >
        <tspan fill="#dc2626">Restore</tspan>
        <tspan fill="#111827">Link</tspan>
      </text>
    </svg>
  );
}

/**
 * Logo text only variant using HTML/CSS for compact spaces
 */
export function LogoText({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      <span className="text-red-600 font-bold">Restore</span>
      <span className="text-gray-900 font-bold">Link</span>
    </span>
  );
}
